export default __webpack_public_path__ + "static/media/honey_explorer_icon.17ccecaa.svg";